import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from 'app';

async function enableMocking() {
    if (import.meta.env.MODE !== 'mock') {
        return;
    }

    const {worker} = await import('./mocks/browser');

    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start();
}

enableMocking().then(() => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <React.StrictMode>
            <App/>
        </React.StrictMode>
    );
});
